import styled from 'styled-components';

export const StyledControls = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center
  
`